import { render, staticRenderFns } from "./ChatbotWidget.vue?vue&type=template&id=b3fa615a&scoped=true&"
import script from "./ChatbotWidget.vue?vue&type=script&lang=js&"
export * from "./ChatbotWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotWidget.scss?vue&type=style&index=0&id=b3fa615a&lang=scss&scoped=true&"
import style1 from "./ChatbotWidget-global.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fa615a",
  null
  
)

export default component.exports